module.exports = __webpack_public_path__ + "Icono_Correo_126px.png";